import { I18N_replaceSlug } from '../I18N/I18N.slugs'
import type { Rpts_OpenReport } from '../Rpts/Rpts.OpenReport'
import type { WF_OpenWorkflow } from './WF.OpenWorkflow'

export const WF_formatOpenWorkflow = async (openReport: Rpts_OpenReport): Promise<WF_OpenWorkflow> => {
    return {
        procedureName: I18N_replaceSlug(openReport.procedure.name),
        workflowName: I18N_replaceSlug(openReport.workflow.name),
        workflowType: openReport.workflow.type,
    }
}
